import { MarketingGuidePage } from '#marketing/components/MarketingGuidePage.jsx';
import { getPublishedGuide } from '#marketing/lib/guide-registry.js';
import {
  marketingGuideRouteMeta,
  marketingRouteMeta,
} from '#marketing/lib/marketing-route-meta.js';

/**
 * @param {{ params: { id?: string } }} args
 */
export function loader({ params }) {
  const guide = getPublishedGuide(params.id ?? '');
  if (!guide) {
    throw new Response('Not Found', { status: 404 });
  }
  return { guide };
}

/**
 * @param {{
 *   matches: Array<{ id?: string, pathname?: string, loaderData?: unknown }>,
 *   params: { id?: string },
 * }} args
 */
export function meta({ matches, params }) {
  const guide = getPublishedGuide(params.id ?? '');
  if (!guide) {
    return marketingRouteMeta({ matches, page: 'guides', pagePath: '/guides' });
  }
  return marketingGuideRouteMeta({ matches, guide });
}

/**
 * @param {{ loaderData: { guide: { id: string, title: string, youtubeId: string } } }} args
 */
export default function Guide({ loaderData }) {
  return <MarketingGuidePage guide={loaderData.guide} />;
}
